import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    let request = req.clone();
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        //lets check for empty 200's that bug out when JSON tries to parse
        if (error.status >= 200 && error.status < 300) {
          const response = new HttpResponse({
            body: null,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText,
            url: error.url
          });
          return of(response);
        } else if (error.status === 401) {
          console.log(error);
          return of(
            new HttpResponse({
              body: error.error || null,
              headers: error.headers,
              status: error.status,
              statusText: error.statusText,
              url: error.url
            })
          );
        } else {
          return observableThrowError(error);
        }
      })
    );
  }
}
